import React, { useState, useEffect } from "react";
import {
  AppProvider,
  LegacyCard,
  TextField,
  Select,
  InlineGrid,
  Spinner,
  Button,
  Icon,
  ChoiceList,
  Checkbox,
} from "@shopify/polaris";
import en from "@shopify/polaris/locales/en.json";
import { jwtDecode } from "jwt-decode";
import { useLocation, useNavigate } from "react-router-dom";
import { useLibrary } from "./LibraryContext";
import { ArrowLeftIcon } from "@shopify/polaris-icons";
import CustomAutocomplete from "./CustomAutocomplete";
import JacketForm from "./OrderFrom/MenJacketForm";
import PantForm from "./OrderFrom/MenPantForm";
import VestForm from "./OrderFrom/MenVestForm";
import ShortForm from "./OrderFrom/MenShortForm";
import DrawstringPant from "./OrderFrom/DrawstringPant";
import DrawstringShort from "./OrderFrom/DrawstringShort";
import MenBomber from "./OrderFrom/MenBomber";
import MenJean from "./OrderFrom/MenJeanForm";
import PartsOrderLabel from "./OrderFrom/PartsOrderLabelForm";
import PartsOrderCuff from "./OrderFrom/PartsOrderCuffForm";
import WomenJacket from "./OrderFrom/WomenJacketForm";
import MenOvercoat from "./OrderFrom/MenOvercoatForm";
import ShirtLongSleeve from "./OrderFrom/ShirtLongSleeveForm";
import ShirtShortSleeve from "./OrderFrom/ShirtShortSleeveForm";
import WomenPantForm from "./OrderFrom/WomenPantForm";
import WomenVestForm from "./OrderFrom/WomenVestForm";
import WomenShortForm from "./OrderFrom/WomenShortForm";
import WomenOvercoatForm from "./OrderFrom/WomenOvercoatForm";
import WomenJeanForm from "./OrderFrom/WomenJeanForm";
import WomenShirtLongSleeveForm from "./OrderFrom/WomenShirtLongSleeveForm";
import WomenShirtShortSleeveForm from "./OrderFrom/WomenShirtShortSleeveForm";
import JacketMeasurements from "./Customers/JacketMeasurements";
import PantMeasurements from "./Customers/PantMeasurements";
import ShortPantMeasurements from "./Customers/ShortPantMeasurements";
import VestMeasurements from "./Customers/VestMeasurements";
import ShirtMeasurements from "./Customers/ShirtMeasurements";
import JeanMeasurements from "./Customers/JeanMeasurements";
import MenOvercoatMeasurements from "./Customers/MenOvercoatMeasurements";
import WomenJacketMeasurements from './Customers/WomenJacketMeasurements';
import WomenPantMeasurements from './Customers/WomenPantMeasurements';
import WomenShortMeasurements from './Customers/WomenShortMeasurements';
import WomenVestMeasurements from './Customers/WomenVestMeasurements';
import WomenShirtMeasurements from './Customers/WomenShirtMeasurements';
import WomenOvercoatMeasurements from './Customers/WomenOvercoatMeasurements';
import WomenJeanMeasurements from './Customers/WomenJeanMeasurements';
import TshirtForm from "./OrderFrom/TshirtForm";
import PalmJacketMeasurements from './Customers/PalmJacketMeasurements';
import PalmJacketForm from "./OrderFrom/PalmJacketForm";
import PartsOrderCollarForm from "./OrderFrom/PartsOrderCollarForm";
import PocketSquareForm from "./OrderFrom/PocketSquareForm";

export default function OrderUpdate() {
  const baseUrl = process.env.REACT_APP_API_URL;
  const { fabrics: Fabrics, linings: LiningNumbers, tshirtFabrics: TshirtFabrics } = useLibrary();
  const location = useLocation();
  const OrderData = location.state?.orderData;
  const ReorderOld = OrderData.json;
  const [customererrors, setCustomerErrors] = useState({});
  const customer_id = ReorderOld?.customer_id_row;
  const updateorderId = OrderData._id;

  const [form, setForm] = useState({});

  const [formCustomer, setformCustomer] = useState({
    name: "",
    gender: "Male",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "Alabama",
    pincode: "",
    country: "United States",
    measurements: {
      jacket: true,
      pant: false,
      shortPant: false,
      vest: false,
      shirt: false,
      jean: false,
      menOvercoat: false,
      womenJacket: false,
      womenPant: false,
      womenShort: false,
      womenVest: false,
      womenShirt: false,
      womenOvercoat: false,
      womenJean: false,
      palmJacket: false,
    },
    jacket: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      jacketLength: "",
      firstButtonPlacement: "",
    },
    pant: {
      waist: "",
      seat: "",
      outseam: "",
      knee: "",
      bottom: "",
    },
    shortPant: {
      waist: "",
      seat: "",
      shortOutseam: "",
      shortBottom: "",
    },
    vest: {
      chest: "",
      stomach: "",
      backLength: "",
      frontLength: ""
    },
    shirt: {
      neck: "",
      chest: "",
      stomach: "",
      shirttHip: "",
      shoulder: "",
      shirtLength: "",
      sleeveL: "",
      sleeveR: "",
      cuffL: "",
      cuffR: "",
      shirtSleeveLenghtL: "",
      shirtSleeveLenghtR: "",
      shortSleeveCuff: "",
    },
    jean: {
      waist: "",
      seat: "",
      thigh: "",
      frontRise: "",
      backRise: "",
      knee: "",
      bottom: "",
      outseam: "",
    },
    menOvercoat: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      overcoatLength: "",
    },
    womenJacket: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      jacketLength: "",
    },
    womenPant: {
      waist: "",
      seat: "",
      uRise: "",
      outSeam: "",
      knee: "",
      bottom: "",
    },
    womenShort: {
      waist: "",
      seat: "",
      uRise: "",
      outSeam: "",
      knee: "",
      bottom: "",
    },
    womenVest: {
      chest: "",
      stomach: "",
      backLength: "",
      firstButton: "",
    },
    womenShirt: {
      neck: "",
      chest: "",
      stomach: "",
      shirtHip: "",
      shoulder: "",
      shirtLength: "",
      sleeveL: "",
      sleeveR: "",
      cuffL: "",
      cuffR: "",
    },
    womenOvercoat: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      overcoatLength: "",
    },
    womenJean: {
      waist: "",
      seat: "",
      thigh: "",
      frontRise: "",
      backRise: "",
      knee: "",
      bottom: "",
      outSeam: "",
    },
    palmJacket: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      jacketLength: "",
      firstButtonPlacement: "",
    },
    bodyNotes: ["headForward"],
    fitType: "regular",
    customerNotes: "",
  });

  useEffect(() => {
    if (ReorderOld) {
      setForm({ ...ReorderOld, orderStatus: OrderData?.orderStatus });
    }
  }, [ReorderOld, OrderData]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      return;
    }

    const fetchCustomer = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/api/customers/${customer_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Customer not found");
        }

        const data = await response.json();
        setformCustomer(data?.json);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    fetchCustomer();
  }, [customer_id, baseUrl]);

  const [errors, setErrors] = useState({});
  const [apploader, setApploader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingMeasurements, setloadingMeasurements] = useState({});
  const [messStatus, setMessStatus] = useState("");
  const navigate = useNavigate();
  const itemtype = [
    "Men Suit",
    "Men 3pc Suit",
    "Men Shirt Long Sleeve",
    "Men Shirt Short Sleeve",
    "Men Jacket",
    "Men Pant",
    "Men Short",
    "Men Vest",
    "Men Bomber",
    "Men Overcoat",
    "Men Jean",
    "Drawstring Pant",
    "Drawstring Short",
    "Women Suit",
    "Women 3pc Suit",
    "Women Jacket",
    "Women Pant",
    "Women Vest",
    "Women Shirt Long Sleeve",
    "Women Shirt Short Sleeve",
    "Women Sleeveless Shirt",
    "Women Short",
    "Women Overcoat",
    "Women Jean",
    "Parts Order Label",
    "Parts Order Cuff",
    "Parts Order Collar",
    "T-Shirt & Polo",
    "The Palm Jacket",
    "Pocket Square",
  ];

  const handleBack = () => {
    navigate(-1);
  };

  const itemTypeChange = (fieldName) => (selectedValue) => {
    setForm((prevForm) => ({
      ...prevForm,
      [fieldName]: selectedValue,
    }));
  };

  const handleChange =
    (section, key = null) =>
      (values) => {
        const trimmedKey = key?.trim();
        let value;
        if (Array.isArray(values)) {
          value = values[0];
        } else {
          value = values;
        }
        const sectionMap = conditionalFieldsMap[section];
        const fieldRule = sectionMap?.[trimmedKey];

        if (fieldRule) {
          const { conditionValue, dependentKey } = fieldRule;
          if (value === conditionValue) {
            // Add the dependent field
            setForm((prev) => ({
              ...prev,
              [section]: {
                ...prev[section],
                [trimmedKey]: value,
                [dependentKey]: "",
              },
            }));
          } else {
            // Remove the dependent field
            const updatedSection = { ...form[section] };
            delete updatedSection[dependentKey];
            updatedSection[trimmedKey] = value;

            setForm((prev) => ({
              ...prev,
              [section]: updatedSection,
            }));
          }

          return;
        }

        // Default update
        if (trimmedKey) {
          setForm((prev) => ({
            ...prev,
            [section]: {
              ...prev[section],
              [trimmedKey]: value,
            },
          }));
        } else {
          setForm((prev) => ({
            ...prev,
            [section]: value,
          }));
        }
      };

  const conditionalFieldsMap = {
    menvest: {
      coveredButton: {
        conditionValue: "Satin Number",
        dependentKey: "coveredButtonSatin",
      },
      tuxedoWrap: {
        conditionValue: "Yes",
        dependentKey: "tuxedoWrapSatin",
      },
      backFabric: {
        conditionValue: "Lining Specify",
        dependentKey: "backFabricLining",
      },
      lapelContrast: {
        conditionValue: ["Lapel", "Lapel edge"],
        dependentKey: "lapelContrastLapel",
      },
    },
    menjacket: {
      chestPocketSqaure: {
        conditionValue: "Other",
        dependentKey: "chestPocketSqaureOther",
      },
      liningNumber: {
        conditionValue: "Custom Images",
        dependentKey: "liningNumberFile",
      },
      nameLabelFont: {
        conditionValue: "Custom Upload",
        dependentKey: "nameLabelFontFile",
      },
    },
  };

  const itemtypeSectionMap = {
    "Men Jacket": "menjacket",
    "Men Suit": ["menjacket", "menpant"],
    "Men Pant": "menpant",
    "Men Short": "menShort",
    "Men Bomber": "menBomber",
    "Men Jean": "menJean",
    "Parts Order Label": "partsOrderLabel",
    "Parts Order Cuff": "partsOrderCuff",
    "Men 3pc Suit": ["menjacket", "menpant", "menVest"],
    "Women Jacket": "womenjacket",
    "Men Overcoat": "menOvercoat",
    "Men Shirt Short Sleeve": "shirtShortSleeve",
    "Men Shirt Long Sleeve": "shirtLongSleeve",
    "Women Pant": "womenpant",
    "Women Vest": "womenvest",
    "Women Short": "womenShort",
    "Women Overcoat": "womenOvercoat",
    "Women Jean": "womenJean",
    "Women Shirt Long Sleeve": "womenShirtLongSleeve",
    "Women Shirt Short Sleeve": "womenShirtShortSleeve",
    "Women Sleeveless Shirt": "womenSleevelessShirt",
  };

  const validate = () => {
    const newErrors = {};

    if (
      (form.DateNeeded === "Event Date" || form.DateNeeded === "Urgent Rush") &&
      !form.NeededDate
    ) {
      newErrors.NeededDate = "Required";
    }
    const selectedSections = itemtypeSectionMap[form.Itemtype];
    const sectionList = Array.isArray(selectedSections)
      ? selectedSections
      : [selectedSections];

    sectionList.forEach((section) => {
      if (!form[section]) return;

      const sectionFields = form[section];
      Object.entries(sectionFields).forEach(([key, value]) => {
        const nameLabelFont = sectionFields.nameLabelFont;
        const nameLabelFontFile = sectionFields.nameLabelFontFile;

        // Skip nameLabelText when Name Label Font is Custom Upload (image used instead)
        if (
          key === "nameLabelText" &&
          nameLabelFont === "Custom Upload" &&
          nameLabelFontFile
        ) {
          return;
        }

        // Skip customLiningTemplate / customLiningFile when Custom Lining is not Yes
        if (
          (key === "customLiningTemplate" || key === "customLiningFile") &&
          sectionFields.customLining !== "Yes"
        ) {
          return;
        }
        if (!value || value === "") {
          if (!newErrors[section]) newErrors[section] = {};
          newErrors[section][key] = "Required";
        }
      });

      const conditionalRules = conditionalFieldsMap[section] || {};
      Object.entries(conditionalRules).forEach(([key, rule]) => {
        const { conditionValue, dependentKey } = rule;
        const fieldValue = sectionFields[key];

        const conditionMet = Array.isArray(conditionValue)
          ? conditionValue.includes(fieldValue)
          : fieldValue === conditionValue;

        if (conditionMet && !sectionFields[dependentKey]) {
          if (!newErrors[section]) newErrors[section] = {};
          newErrors[section][dependentKey] = "Required";
        }
      });
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (orderType) => {
    if (!validate()) return;
    const token = localStorage.getItem("token");

    if (!token) {
      return;
    }
    setLoading(true);
    const updatedForm = {
      ...form,
      ...(orderType ? { orderStatus: orderType } : {}),
    };
    fetch(`${baseUrl}/api/orders/${updateorderId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedForm),
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || "order update failed!");
        }
        setMessStatus(`Order updated successfully.`);
        setTimeout(function () {
          //navigate("/dashboard/orders");
          navigate("/dashboard/orders");
        }, 2000);
      })
      .catch((error) => {
        setMessStatus(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Customer Measurements Validate
  const typeCheckName = form?.Itemtype;
  const Customervalidate = (form, sectionKey) => {
    const newErrors = {};
    const updatedErrors = { ...form.customerErrors };

    if (form.measurements[sectionKey]) {
      Object.entries(form[sectionKey]).forEach(([subKey, value]) => {
        if (sectionKey === "jacket" && subKey === "firstButtonPlacement") return;
        if (sectionKey === "womenVest" && subKey === "firstButton") return;
        if ((sectionKey === "vest" && subKey === "firstButtonPlacement") || subKey === "frontLength") return;
        if (typeCheckName === "Men Shirt Long Sleeve") {
          if (
            (sectionKey === "shirt" && subKey === "shirtSleeveLenghtL") ||
            subKey === "shirtSleeveLenghtR" ||
            subKey === "shortSleeveCuff"
          )
            return;
        }
        if (typeCheckName === "Men Shirt Short Sleeve" || typeCheckName === "T-Shirt & Polo") {
          if (
            (sectionKey === "shirt" && subKey === "sleeveL") ||
            subKey === "sleeveR" || subKey === "cuffR" ||
            subKey === "cuffL"
          )
            return;
        }
        if (!value) {
          if (!newErrors[sectionKey]) newErrors[sectionKey] = {};
          newErrors[sectionKey][subKey] = "Required";
        } else {
          if (updatedErrors[sectionKey]?.[subKey]) {
            delete updatedErrors[sectionKey][subKey];
            if (Object.keys(updatedErrors[sectionKey]).length === 0) {
              delete updatedErrors[sectionKey];
            }
          }
        }
      });
    }

    setCustomerErrors({ ...updatedErrors, ...newErrors });
    return Object.keys(newErrors).length === 0;
  };

  // Customer Measurements Submit
  const [customerMess, setCustomerMess] = useState({});
  const CustomerhandleSubmit = (sectionKey) => {
    const updatedFormData = {
      ...formCustomer,
      measurements: {
        ...formCustomer.measurements,
        [sectionKey]: true,
      },
    };
    setformCustomer(updatedFormData);
    if (!Customervalidate(updatedFormData, sectionKey)) return;

    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const adminrole = decoded.role;
    if (!token) {
      return;
    }

    setloadingMeasurements((prev) => ({ ...prev, [sectionKey]: true }));
    const updatedForm = {
      ...formCustomer,
      adminrole: adminrole,
    };
    fetch(`${baseUrl}/api/customers/${customer_id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedForm),
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || "update failed!");
        }
        setCustomerMess((prev) => ({
          ...prev,
          [sectionKey]: "Saved successfully!",
        }));
      })
      .catch((error) => {
        setCustomerMess((prev) => ({
          ...prev,
          [sectionKey]: error.message,
        }));
      })
      .finally(() => {
        setloadingMeasurements((prev) => ({ ...prev, [sectionKey]: false }));
        setTimeout(() => {
          setCustomerMess((prev) => ({
            ...prev,
            [sectionKey]: "",
          }));
        }, 3000);
      });
  };

  return (
    <AppProvider i18n={en}>
      <div className="button_option">
        <h2>
          <span onClick={handleBack}>
            <Icon source={ArrowLeftIcon} tone="base" />
          </span>
          Edit Order
        </h2>
      </div>
      <LegacyCard title="Customer Information" sectioned>
        <InlineGrid columns={{ xs: 1, sm: 2, md: 2, lg: 3 }} gap="400">
          <TextField
            label="Order ID"
            value={OrderData.orderId}
            placeholder="Order Id"
            readOnly
          />
          <TextField
            label="Full Name"
            value={ReorderOld?.customerName}
            placeholder="Full Name"
            readOnly
          />
          <TextField
            label="Customer ID"
            value={ReorderOld?.CustomerID}
            placeholder="Customer ID"
            readOnly
          />
        </InlineGrid>
      </LegacyCard>
      <LegacyCard title="Basic Information" sectioned>
        <InlineGrid columns={{ xs: 1, sm: 2, md: 2, lg: 3 }} gap="400">
          <Select
            label="Item Type"
            options={itemtype}
            onChange={itemTypeChange("Itemtype")}
            value={form.Itemtype}
            disabled
          />
          {form.Itemtype !== "Pocket Square" && (
            <CustomAutocomplete
              label="Fabric Number"
              optionsList={form.Itemtype === "T-Shirt & Polo" ? TshirtFabrics : Fabrics}
              onChange={handleChange("FabricNumber")}
              defaultValue={form.FabricNumber}
            />
          )}
          <div className="two_culumn">
            <Select
              label="Date Needed"
              options={["Normal", "Event Date", "Urgent Rush"]}
              onChange={handleChange("DateNeeded")}
              value={form.DateNeeded}
            />
            {form.DateNeeded === "Event Date" ||
              form.DateNeeded === "Urgent Rush" ? (
              <TextField
                label="Date"
                value={form.NeededDate}
                onChange={handleChange("NeededDate")}
                error={errors.NeededDate}
                placeholder="MM-DD-YYYY"
              />
            ) : null}
          </div>
        </InlineGrid>
      </LegacyCard>

      {form?.Itemtype && !["Parts Order Label", "Parts Order Cuff", "Parts Order Collar", "Pocket Square"].includes(form?.Itemtype) && (
        <div className="customer_body_option view-mode-readonly">
          <LegacyCard title="Body Notes" sectioned>
            <ChoiceList
              allowMultiple
              choices={[
                { label: "Head Forward", value: "Head Forward" },
                { label: "Left Shoulder Down", value: "Left Shoulder Down" },
                { label: "Right Shoulder Down", value: "Right Shoulder Down" },
                { label: "Left Shoulder Up", value: "Left Shoulder Up" },
                { label: "Right Shoulder Up", value: "Right Shoulder Up" },
                { label: "Humpback", value: "Humpback" },
                { label: "Arms Forward", value: "Arms Forward" },
                { label: "Arms Backward", value: "Arms Backward" },
                { label: "Chest Out", value: "Chest Out" },
                { label: "Stomach Out", value: "Stomach Out" },
                { label: "Large Bicep", value: "Large Bicep" },
                { label: "Large Calf", value: "Large Calf" },
              ]}
              selected={formCustomer?.bodyNotes || []}
              onChange={() => {}}
            />
          </LegacyCard>
        </div>
      )}

      {form?.Itemtype && !["Parts Order Label", "Parts Order Cuff", "Parts Order Collar", "Pocket Square"].includes(form?.Itemtype) && (
        <LegacyCard title="Measurements Updated" sectioned>
          <Checkbox
            label="Measurements Updated For This Order"
            checked={form.measurementsUpdated || false}
            onChange={(val) => setForm({ ...form, measurementsUpdated: val })}
          />
        </LegacyCard>
      )}

      {["Men Suit", "Men 3pc Suit", "Men Jacket", "Men Bomber"].includes(form?.Itemtype) && (
        <JacketMeasurements
          values={formCustomer.jacket}
          message={customerMess.jacket}
          loading={loadingMeasurements.jacket}
          onSave={() => CustomerhandleSubmit("jacket")}
          errors={customererrors.jacket}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              jacket: { ...prev.jacket, [key]: value },
            }))
          }
        />
      )}

      {["Men Vest", "Men 3pc Suit"].includes(form?.Itemtype) && (
        <VestMeasurements
          values={formCustomer.vest}
          message={customerMess.vest}
          loading={loadingMeasurements.vest}
          onSave={() => CustomerhandleSubmit("vest")}
          errors={customererrors.vest}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              vest: { ...prev.vest, [key]: value },
            }))
          }
        />
      )}

      {["Men Suit", "Men 3pc Suit", "Men Pant", "Drawstring Pant"].includes(form?.Itemtype) && (
        <PantMeasurements
          values={formCustomer.pant}
          message={customerMess.pant}
          loading={loadingMeasurements.pant}
          onSave={() => CustomerhandleSubmit("pant")}
          errors={customererrors.pant}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              pant: { ...prev.pant, [key]: value },
            }))
          }
        />
      )}

      {["Men Short", "Drawstring Short"].includes(form?.Itemtype) && (
        <ShortPantMeasurements
          values={formCustomer.shortPant}
          message={customerMess.shortPant}
          loading={loadingMeasurements.shortPant}
          onSave={() => CustomerhandleSubmit("shortPant")}
          errors={customererrors.shortPant}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              shortPant: { ...prev.shortPant, [key]: value },
            }))
          }
        />
      )}


      {["Men Shirt Short Sleeve", "Men Shirt Long Sleeve"].includes(form?.Itemtype) && (
        <ShirtMeasurements
          values={formCustomer.shirt}
          message={customerMess.shirt}
          loading={loadingMeasurements.shirt}
          onSave={() => CustomerhandleSubmit("shirt")}
          errors={customererrors.shirt}
          dataType={form.Itemtype}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              shirt: { ...prev.shirt, [key]: value },
            }))
          }
        />
      )}

      {["Men Jean"].includes(form?.Itemtype) && (
        <JeanMeasurements
          values={formCustomer.jean}
          message={customerMess.jean}
          loading={loadingMeasurements.jean}
          onSave={() => CustomerhandleSubmit("jean")}
          errors={customererrors.jean}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              jean: { ...prev.jean, [key]: value },
            }))
          }
        />
      )}

      {["Men Overcoat"].includes(form?.Itemtype) && (
        <MenOvercoatMeasurements
          values={formCustomer.menOvercoat}
          message={customerMess.menOvercoat}
          loading={loadingMeasurements.menOvercoat}
          onSave={() => CustomerhandleSubmit("menOvercoat")}
          errors={customererrors.menOvercoat}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              menOvercoat: { ...prev.menOvercoat, [key]: value },
            }))
          }
        />
      )}

      {["Women Jacket", "Women Suit", "Women 3pc Suit"].includes(form?.Itemtype) && (
        <WomenJacketMeasurements
          values={formCustomer.womenJacket}
          message={customerMess.womenJacket}
          loading={loadingMeasurements.womenJacket}
          onSave={() => CustomerhandleSubmit("womenJacket")}
          errors={customererrors.womenJacket}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenJacket: { ...prev.womenJacket, [key]: value },
            }))
          }
        />
      )}

      {["Women Pant", "Women Suit", "Women 3pc Suit"].includes(form?.Itemtype) && (
        <WomenPantMeasurements
          values={formCustomer.womenPant}
          message={customerMess.womenPant}
          loading={loadingMeasurements.womenPant}
          onSave={() => CustomerhandleSubmit("womenPant")}
          errors={customererrors.womenPant}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenPant: { ...prev.womenPant, [key]: value },
            }))
          }
        />
      )}

      {["Women Short"].includes(form?.Itemtype) && (
        <WomenShortMeasurements
          values={formCustomer.womenShort}
          message={customerMess.womenShort}
          loading={loadingMeasurements.womenShort}
          onSave={() => CustomerhandleSubmit("womenShort")}
          errors={customererrors.womenShort}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenShort: { ...prev.womenShort, [key]: value },
            }))
          }
        />
      )}

      {["Women Vest", "Women 3pc Suit"].includes(form?.Itemtype) && (
        <WomenVestMeasurements
          values={formCustomer.womenVest}
          message={customerMess.womenVest}
          loading={loadingMeasurements.womenVest}
          onSave={() => CustomerhandleSubmit("womenVest")}
          errors={customererrors.womenVest}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenVest: { ...prev.womenVest, [key]: value },
            }))
          }
        />
      )}

      {["Women Shirt", "Women Shirt Short Sleeve", "Women Shirt Long Sleeve"].includes(form?.Itemtype) && (
        <WomenShirtMeasurements
          values={formCustomer.womenShirt}
          message={customerMess.womenShirt}
          loading={loadingMeasurements.womenShirt}
          onSave={() => CustomerhandleSubmit("womenShirt")}
          errors={customererrors.womenShirt}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenShirt: { ...prev.womenShirt, [key]: value },
            }))
          }
        />
      )}

      {["Women Overcoat"].includes(form?.Itemtype) && (
        <WomenOvercoatMeasurements
          values={formCustomer.womenOvercoat}
          message={customerMess.womenOvercoat}
          loading={loadingMeasurements.womenOvercoat}
          onSave={() => CustomerhandleSubmit("womenOvercoat")}
          errors={customererrors.womenOvercoat}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenOvercoat: { ...prev.womenOvercoat, [key]: value },
            }))
          }
        />
      )}

      {["Women Jean"].includes(form?.Itemtype) && (
        <WomenJeanMeasurements
          values={formCustomer.womenJean}
          message={customerMess.womenJean}
          loading={loadingMeasurements.womenJean}
          onSave={() => CustomerhandleSubmit("womenJean")}
          errors={customererrors.womenJean}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              womenJean: { ...prev.womenJean, [key]: value },
            }))
          }
        />
      )}
      {["T-Shirt & Polo"].includes(form?.Itemtype) && (
        <ShirtMeasurements
          values={formCustomer.shirt}
          message={customerMess.shirt}
          loading={loadingMeasurements.shirt}
          onSave={() => CustomerhandleSubmit("shirt")}
          errors={customererrors.shirt}
          dataType="T-Shirt & Polo"
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              shirt: { ...prev.shirt, [key]: value },
            }))
          }
        />
      )}
      {["The Palm Jacket"].includes(form?.Itemtype) && (
        <PalmJacketMeasurements
          values={formCustomer.palmJacket}
          message={customerMess.palmJacket}
          loading={loadingMeasurements.palmJacket}
          onSave={() => CustomerhandleSubmit("palmJacket")}
          errors={customererrors.palmJacket}
          onChange={(key) => (value) =>
            setformCustomer((prev) => ({
              ...prev,
              palmJacket: { ...prev.palmJacket, [key]: value },
            }))
          }
        />
      )}
      {["Men Jacket", "Men Suit", "Men 3pc Suit"].includes(form?.Itemtype) && (
        <JacketForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Men Vest", "Men 3pc Suit"].includes(form?.Itemtype) && (
        <VestForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Men Pant", "Men Suit", "Men 3pc Suit"].includes(form?.Itemtype) && (
        <PantForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}

      {["Men Short"].includes(form?.Itemtype) && (
        <ShortForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Women Short"].includes(form?.Itemtype) && (
        <WomenShortForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Drawstring Pant"].includes(form?.Itemtype) && (
        <DrawstringPant
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Drawstring Short"].includes(form?.Itemtype) && (
        <DrawstringShort
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Men Bomber"].includes(form?.Itemtype) && (
        <MenBomber
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Men Jean"].includes(form?.Itemtype) && (
        <MenJean
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Women Jean"].includes(form?.Itemtype) && (
        <WomenJeanForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Parts Order Label"].includes(form?.Itemtype) && (
        <PartsOrderLabel
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Parts Order Cuff"].includes(form?.Itemtype) && (
        <PartsOrderCuff
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Parts Order Collar"].includes(form?.Itemtype) && (
        <PartsOrderCollarForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
        />
      )}
      {["Pocket Square"].includes(form?.Itemtype) && (
        <PocketSquareForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
        />
      )}
      {["T-Shirt & Polo"].includes(form?.Itemtype) && (
        <TshirtForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
        />
      )}
      {["The Palm Jacket"].includes(form?.Itemtype) && (
        <PalmJacketForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
        />
      )}
      {["Women Jacket", "Women Suit", "Women 3pc Suit"].includes(
        form?.Itemtype
      ) && (
          <WomenJacket
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
          />
        )}
      {["Women Pant", "Women Suit", "Women 3pc Suit"].includes(
        form?.Itemtype
      ) && (
          <WomenPantForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
          />
        )}
      {["Women Vest", "Women 3pc Suit"].includes(form?.Itemtype) && (
        <WomenVestForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}

      {["Men Overcoat"].includes(form?.Itemtype) && (
        <MenOvercoat
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Women Overcoat"].includes(form?.Itemtype) && (
        <WomenOvercoatForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Men Shirt Long Sleeve"].includes(form?.Itemtype) && (
        <ShirtLongSleeve
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Women Shirt Long Sleeve"].includes(form?.Itemtype) && (
        <WomenShirtLongSleeveForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Men Shirt Short Sleeve"].includes(form?.Itemtype) && (
        <ShirtShortSleeve
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      {["Women Shirt Short Sleeve"].includes(form?.Itemtype) && (
        <WomenShirtShortSleeveForm
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          baseUrl={baseUrl}
          setApploader={setApploader}
          conditionalFieldsMap={conditionalFieldsMap}
        />
      )}
      <LegacyCard title="Order Status" sectioned>
        <ChoiceList
          choices={[
            { label: "Draft", value: "Draft" },
            { label: "Submitted", value: "Submitted" },
            { label: "Production", value: "Production" },
            { label: "Shipping", value: "Shipping" },
            { label: "Delivered", value: "Delivered" },
          ]}
          selected={[form.orderStatus]}
          onChange={(value) => setForm({ ...form, orderStatus: value[0] })}
        />
      </LegacyCard>
      <LegacyCard title="Quantity" sectioned>
        <InlineGrid columns={{ xs: 1, sm: 2, md: 2, lg: 3 }} gap="400">
          <TextField
            label=""
            type="number"
            min="1"
            value={form.Qty || "1"}
            onChange={handleChange("Qty")}
            placeholder="1"
            autoComplete="off"
          />
        </InlineGrid>
      </LegacyCard>
      <LegacyCard title="NOTES" sectioned>
        <InlineGrid columns={1} gap="300">
          <div className="order_notes">
            <TextField
              value={form.orderNotes}
              onChange={handleChange("orderNotes")}
              error={errors.orderNotes}
              placeholder="Add your notes here..."
            />
          </div>
        </InlineGrid>
      </LegacyCard>

      {messStatus && <p className="sucess_mess">{messStatus}</p>}
      <div className="customerAddBtn">
        {!loading ? (
          <>
            <Button variant="primary" onClick={() => handleSubmit()}>
              Save Order
            </Button>
            {OrderData?.orderStatus === "Draft" && (
              <Button variant="primary" onClick={() => handleSubmit("Submitted")}>
                Submit Order
              </Button>
            )}
          </>
        ) : (
          <Spinner accessibilityLabel="Adding customer" size="small" />
        )}
      </div>
      {apploader ? (
        <div className="app_loader">
          <Spinner accessibilityLabel="Adding customer" size="small" />
        </div>
      ) : null}
    </AppProvider>
  );
}
